import React from 'react';
import { FormattedMessage } from 'react-intl';
import { intl } from '../../../locales/localesConfig';
import InterfaceTooling from '../../../tooling/interfaceTooling';

import Button from '../common/inputs/button';
import Constants from '../../../definitions/constants';

const Header = props => {
  const {
    disabledImportButton,
    disableDeleteButton,
    disableExportButton,
    disabledCreateButton,
    hideDeleteMarksButton,
    loadingExportButton,
    loadingRefreshVirtualMetricsButton,
    handleImportFormPopup,
    handleDeleteMetricsData,
    handleExportMetricsData,
    handleCreate,
    handleLoadDataInfoPopup,
    handleDeleteMarksButton,
    importButtonLabel,
    metricsMetricType,
    additionalData
  } = props;
  
  let virtualMetricRegeneratePending = false
  if(!disabledImportButton && additionalData && additionalData.upload_info &&
      metricsMetricType == Constants.metricAdmin.metricType.VIRTUAL) {
    additionalData.upload_info.forEach((metricUploadInfo) => {
      if(metricUploadInfo.virtual_metric_regenerate_pending) {
        virtualMetricRegeneratePending = true
      }
    })
  }

  return (
    <div className="entity_header metric_data_admin_header">
      <div className='entity_title'>
        <FormattedMessage id="metricDataAdmin.title"/>
        {(!(metricsMetricType == Constants.metricAdmin.metricType.STANDARD) && (metricsMetricType)) && (
           <span>{" - "}<FormattedMessage id={"metricAdmin.fields.selectValues.metric_type." + metricsMetricType}/></span>
        )}
      </div>
      <div className="entity_header_buttons_wrapper">        
        {(handleDeleteMarksButton && !hideDeleteMarksButton) && (
          <Button
            onClick={handleDeleteMarksButton}
            labelLocale={<FormattedMessage id="metricDataAdmin.deleteMarksButtonTitle"/>}
            className={"delete_marks_button"}
          />
        )} 
        {handleDeleteMetricsData && (
          <Button
            disabled={disableDeleteButton}
            onClick={handleDeleteMetricsData}
            labelLocale={<FormattedMessage id="metricDataAdmin.deleteButtonTitle"/>}
            className={"delete_button"}
          />
        )}        
        {handleExportMetricsData && (
          <Button
            loading={loadingExportButton}
            disabled={disableExportButton || loadingExportButton}
            onClick={handleExportMetricsData}
            labelLocale={<FormattedMessage id="metricDataAdmin.exportButtonTitle"/>}
          />
        )}
        {handleImportFormPopup && (
          <Button
            loading={loadingRefreshVirtualMetricsButton}
            disabled={
              (!virtualMetricRegeneratePending && metricsMetricType == Constants.metricAdmin.metricType.VIRTUAL)
              || disabledImportButton || loadingRefreshVirtualMetricsButton}
            onClick={handleImportFormPopup}
            labelLocale={(virtualMetricRegeneratePending || 
              metricsMetricType != Constants.metricAdmin.metricType.VIRTUAL ||
              disabledImportButton) ? 
              importButtonLabel : <FormattedMessage id="metricDataAdmin.refreshVirtualMetricDataLabelReady"/>}
            className={(metricsMetricType == Constants.metricAdmin.metricType.VIRTUAL && virtualMetricRegeneratePending) ? "virtual_metric_refresh_button_pending" : ""}   
          />
        )}
        {handleCreate && (
          <Button
            disabled={disabledCreateButton}
            onClick={handleCreate}
            labelLocale={<FormattedMessage id="metricDataAdmin.createButtonTitle"/>}
            className={"create_button"}
          />
        )}
        {(handleLoadDataInfoPopup) && (
          <label className="info_button">
            <i className="fas fa-info-circle" onClick={handleLoadDataInfoPopup}></i>
          </label>
        )}
      </div>
    </div>
  );
};

export default Header;



// WEBPACK FOOTER //
// ./source/client/components/metricDataAdmin/header.jsx